export const VisitOptionVideoVisitIcon = ({ color = 'black', size = 46, strokeWidth = '1.75' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ minWidth: size, minHeight: size }}
    >
        <g id="video-recorder">
            d
            <g id="Icon">
                <path
                    d="M18.3337 7.44265C18.3337 6.9378 18.3337 6.68538 18.2338 6.56849C18.1472 6.46707 18.0173 6.41325 17.8843 6.42371C17.7311 6.43577 17.5526 6.61426 17.1956 6.97124L14.167 9.99984L17.1956 13.0284C17.5526 13.3854 17.7311 13.5639 17.8843 13.576C18.0173 13.5864 18.1472 13.5326 18.2338 13.4312C18.3337 13.3143 18.3337 13.0619 18.3337 12.557V7.44265Z"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.66699 8.1665C1.66699 6.76637 1.66699 6.06631 1.93948 5.53153C2.17916 5.06112 2.56161 4.67867 3.03202 4.43899C3.5668 4.1665 4.26686 4.1665 5.66699 4.1665H10.167C11.5671 4.1665 12.2672 4.1665 12.802 4.43899C13.2724 4.67867 13.6548 5.06112 13.8945 5.53153C14.167 6.06631 14.167 6.76637 14.167 8.1665V11.8332C14.167 13.2333 14.167 13.9334 13.8945 14.4681C13.6548 14.9386 13.2724 15.321 12.802 15.5607C12.2672 15.8332 11.5671 15.8332 10.167 15.8332H5.66699C4.26686 15.8332 3.5668 15.8332 3.03202 15.5607C2.56161 15.321 2.17916 14.9386 1.93948 14.4681C1.66699 13.9334 1.66699 13.2333 1.66699 11.8332V8.1665Z"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
    </svg>
)
